import { render } from "./activation.vue?vue&type=template&id=3b427f44"
import script from "./activation.js?vue&type=script&lang=js&external"
export * from "./activation.js?vue&type=script&lang=js&external"

import "./activation.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__